import { CalculationIntervals } from "@finway-group/shared/lib/consts"
import { CalculationIntervalEnum } from "@finway-group/shared/lib/models"
import { Store } from "antd/lib/form/interface"
import moment from "moment"
import { useTranslation } from "react-i18next"

import { AnalyticsService, CostCenterService, UserService } from "Shared/services"
import { getStartAndEndDateOfInterval } from "Shared/utils/helpers"

import { ReportingFilterInterface } from "./reportingFilter.interface"

export const convertFilterObjectIntoQueryFormat = (values: Store): any => {
    const result: any = {}

    if (values.minDate) result.minDate = { ...result.minDate, gte: values.minDate.toISOString() }
    if (values.maxDate) result.maxDate = { ...result.maxDate, lte: values.maxDate.toISOString() }
    if (values.costCenter) result.costCenters = { eq: values.costCenter }

    return result
}

export const convertQueryFormatIntoFilterObject = (query: any): ReportingFilterInterface => ({
    minDate: (query.minDate && moment(query.minDate)) || "",
    maxDate: (query.maxDate && moment(query.maxDate)) || "",
    costCenters: query.costCenters,
})

export const getSelectLabel = (label: string) => {
    const { t } = useTranslation()

    switch (label) {
        case CalculationIntervals[CalculationIntervalEnum.ALL_TIME]:
            return t("label:all_times")
        case CalculationIntervals[CalculationIntervalEnum.CURRENT_YEAR]:
            return t("label:current_year")
        case CalculationIntervals[CalculationIntervalEnum.CURRENT_MONTH]:
            return t("label:current_month")
        default:
            return ""
    }
}

export const getCostCenterExpenseDataByInterval = async (value: CalculationIntervalEnum) => {
    const { globalCurrency } = UserService.getLoggedInEmployeeProfile().settings
    const costCenterIds = CostCenterService.getCostCenterIds(true, true)
    const timeInterval = getStartAndEndDateOfInterval(Number(value) as CalculationIntervalEnum)
    const expensePerCostCenter = await AnalyticsService.fetchExpenseDataForGroup("costCenter", costCenterIds, globalCurrency, timeInterval)
    return expensePerCostCenter
}

export const filterOvertimeAnalyticsDataByDateRange = (startDate: moment.Moment, endDate: moment.Moment, arrayToFilter: Array<any>) =>
    arrayToFilter.filter((elem) => moment(`${elem.year}${elem.month + 1}`, "YYYYMM").isBetween(startDate.startOf("month"), endDate.endOf("month"), undefined, "[]"))
